import React from "react";
import "./scss/featured.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const Featured = () => {
  return (
    <div className="featured">
      <div className="top">
        <h1 className="title">Total Revenue</h1>
        <MoreVertIcon fontSize="small" />
      </div>
      <div className="bottom">
        <div className="featuredChart">
          <CircularProgressbar value={70} text={"70%"} strokeWidth={"4"} />
        </div>
        <p className="title">Total sales made today</p>
        <p className="amount">$420</p>
        <p className="desc">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita,
          blanditiis.
        </p>
        <div className="summary">
          <div className="item">
            <div className="itemTitle">Target</div>
            <div className="res negative">
              <KeyboardArrowDownOutlinedIcon fontSize="small" />
              <div className="resAmount">$12.8k</div>
            </div>
          </div>
          <div className="item">
            <div className="itemTitle">Last Week</div>
            <div className="res positive">
              <KeyboardArrowUpOutlinedIcon fontSize="small" />
              <div className="resAmount">$24.7k</div>
            </div>
          </div>
          <div className="item">
            <div className="itemTitle">Last Month</div>
            <div className="res positive">
              <KeyboardArrowUpOutlinedIcon fontSize="small" />
              <div className="resAmount">$50.2k</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
